import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_API_URL, {
  transports: ['websocket'],
  autoConnect: false, // Don't connect until we have a token
});

export default socket;
